/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { GenerateReceiptPdfErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const generateReceiptPdf = (encounterId: number, signal?: AbortSignal) => {
  return api<Blob>({
    url: `/api/encounters/${encounterId}/receipt-pdf`,
    method: 'POST',
    responseType: 'blob',
    signal,
  });
};

export const getGenerateReceiptPdfMutationOptions = <
  TError = GenerateReceiptPdfErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReceiptPdf>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateReceiptPdf>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['generateReceiptPdf'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateReceiptPdf>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return generateReceiptPdf(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateReceiptPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateReceiptPdf>>
>;

export type GenerateReceiptPdfMutationError = GenerateReceiptPdfErrorResponse;

export const useGenerateReceiptPdf = <TError = GenerateReceiptPdfErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateReceiptPdf>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateReceiptPdf>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions = getGenerateReceiptPdfMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
